"use client";

import { useEffect } from "react";

type PiWindow = Window & {
  Pi?: {
    init?: (opts?: { version?: string }) => any;
    authenticate?: (
      scopes: string[],
      onIncompletePaymentFound?: (payment: any) => void
    ) => Promise<any>;
  };
  __isPi?: boolean;
  __piReady?: Promise<boolean>;
  __piInited?: boolean;
  ReloadPiNative?: { openExternal: (url: string) => Promise<void> | void };
  isNativeWrapper?: boolean;
  Capacitor?: any;
};

export default function PiBootstrap() {
  useEffect(() => {
    const w = window as PiWindow;

    // --- 1) Capacitor helpers (safe access) ---
    try {
      const cap = w.Capacitor;
      const isObj = cap && typeof cap === "object";
      if (isObj) w.isNativeWrapper = true;

      async function openExternal(url: string) {
        try {
          const plugins = isObj ? (cap as any).Plugins : undefined;
          const Browser =
            plugins && typeof plugins === "object" ? plugins.Browser : undefined;
          if (Browser?.open) return Browser.open({ url });
        } catch {}
        window.open(url, "_blank", "noopener,noreferrer");
      }

      w.ReloadPiNative = { openExternal };

      const plugins = isObj ? (cap as any).Plugins : undefined;
      const App = plugins && typeof plugins === "object" ? plugins.App : undefined;

      if (App?.addListener) {
        App.addListener("backButton", () => {
          try {
            if (history.length > 1) history.back();
            else App.exitApp?.();
          } catch {}
        });
      }
    } catch {}

    // --- 2) Pi readiness (init once, never throw, no UI logs) ---
    w.__piReady = new Promise((resolve) => {
      const start = Date.now();

      const tick = () => {
        try {
          if (w.Pi && typeof w.Pi.init === "function") {
            if (!w.__piInited) {
              try {
                w.Pi.init({ version: "2.0" });
              } catch {}
              w.__piInited = true;
            }
            w.__isPi = true;
            resolve(true);
            return;
          }
        } catch {}

        if (Date.now() - start > 5000) {
          w.__isPi = false;
          resolve(false);
          return;
        }

        setTimeout(tick, 50);
      };

      tick();
    });
  }, []);

  return null;
}
